import bankApi from '@/api/pumba/bankApi';
import { API_URLS } from '@/api/pumba/urls';
import { Form } from '@/services/form';

const formBankAccountObject = {
    bank_code: '',
    agency: '',
    agency_digit: '0',
    // Account used in v-model, used to prevent the user seeing the last digit disappears when slice method is called
    account_with_digit: '',

    // Account and digit send to the request
    account: '',
    account_digit: '',
    operation_code: 'Conta Corrente',
};

export const state = {
    bank: null,
    formBankAccount: new Form(formBankAccountObject),

    // This state will be sent to the request, to avoid the input field being cleared
    formBankAccountSubmit: new Form(formBankAccountObject),

    sending: false,
    loading: false,
};

export const getters = {
    getBankAccounts: (states) => states.bank,
    formBankAccount: (states) => states.formBankAccount,
    form: (states) => states.form,
    loading: (states) => states.loading,
};

export const mutations = {
    ['UPDATE_BANK'](states, value) {
        states.bank = value;
    },

    ['UPDATE_FORM_BANK_ACCOUNT_VALUE'](states, { index, value }) {
        states.formBankAccount[index] = value;
    },

    ['SET_FORM_VALUES'](states, value) {
        states.formBankAccount = value;
    },

    ['RESET_FORM_BANK_ACCOUNT'](states) {
        states.formBankAccount.reset();
    },
};

export const actions = {
    async loadBankAccount({ dispatch, commit }) {
        const data = await bankApi.fetchAccount();

        commit('UPDATE_BANK', data);

        if (data.data[0]) {
            const payload = { bankAccount: data.data[0] };
            dispatch('setFormValues', payload);
        }
    },
    async submit({ state: states, commit }, payload) {
        const { account_with_digit } = states.formBankAccount;

        // Splitting the account number and account digit to be saved on database
        const accountNumber = account_with_digit.slice(0, -1);
        const accountDigit = account_with_digit.charAt(account_with_digit.length - 1);

        commit('UPDATE_FORM_BANK_ACCOUNT_VALUE', { index: 'account', value: accountNumber });
        commit('UPDATE_FORM_BANK_ACCOUNT_VALUE', { index: 'account_digit', value: accountDigit });

        // Checking if the user already has an account
        const payloadData = payload.bankAccount;
        if (payloadData) {
            const putUrl = API_URLS.BANKS.ACCOUNTS_PUT(payloadData.id);
            await states.formBankAccount.put(putUrl);
        } else {
            await states.formBankAccount.post(API_URLS.BANKS.ACCOUNTS);
        }
        commit('RESET_FORM_BANK_ACCOUNT');
    },
    setFormValues({ commit }, payload) {
        const { account, account_digit, agency, bank_code, operation_code } = payload.bankAccount;

        // Setting the values to be displayed on form
        commit('UPDATE_FORM_BANK_ACCOUNT_VALUE', { index: 'bank_code', value: bank_code });
        commit('UPDATE_FORM_BANK_ACCOUNT_VALUE', { index: 'agency', value: agency });
        commit('UPDATE_FORM_BANK_ACCOUNT_VALUE', { index: 'account_with_digit', value: account.concat(account_digit) });
        commit('UPDATE_FORM_BANK_ACCOUNT_VALUE', { index: 'operation_code', value: operation_code });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
